export const setProducts = () => {
  return {
    type: 'SET_PRODUCTS'
  };
}

export const setProductVariantStock = () => {
  return {
    type: 'SET_PRODUCTS_VARIANT_STOCK'
  }
}

export const setData = (data) => {
  return {
    type: 'SET_DATA',
    data
  };
}

export const setPopupTrigger = (trigger) => {
  return {
    type: 'SET_POPUP_TRIGGER',
    trigger
  };
}
